import React, { useRef, useEffect } from "react";
import styles from "./modal-table.module.scss";
import { TableHeader } from "./table-header.component";
import { TableBody } from "./table-body.component";

export const ModalTable = ({ metric = null }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleWheel = (e) => {
      // If shift key is pressed or horizontal scroll is detected, scroll horizontally
      if (e.shiftKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        container.scrollLeft += e.deltaX || e.deltaY;
        return;
      }
      
      // For vertical scroll, convert to horizontal scroll
      // Only if there's horizontal overflow
      if (container.scrollWidth > container.clientWidth) {
        e.preventDefault();
        container.scrollLeft += e.deltaY;
      }
    };

    container.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      container.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <div ref={containerRef} className={styles.modalTableContainer}>
      <TableHeader metric={metric} />
      <TableBody metric={metric} />
    </div>
  );
};
